import { BehaviorSubject } from 'rxjs';

export const _longTermTokenInitialValue = {
  token: '',
  isValid: false,
  isTokenDelete: true, // as default we want to delete token
};

const subject = new BehaviorSubject(_longTermTokenInitialValue);

/**
 * Publishes a valid token by emitting a new event
 * @param token
 */
const publishValidToken = (token: string): void => {
  subject.next({ isValid: true, token, isTokenDelete: true });
};

/**
 * Invalidates the token by emitting a new event
 * - keeps the invalid token so it can be used to refresh
 * - won't be necessary when we have a http only refresh token
 * @returns the value of the token
 */
const invalidateToken = (): string => {
  const token = subject.value.token;
  subject.next({ token, isValid: false, isTokenDelete: true });
  return token;
};

/**
 * Clears the token by emitting a new event
 */
const clearToken = (): void => {
  subject.next({ isValid: false, token: '', isTokenDelete: true });
};

/**
 * @returns whether there is a token or not, regardless of whether it's valid or not
 */
const hasToken = (): boolean => {
  return subject.value.token.length > 0;
};

/**
 * @returns the value of the token regardless of whether it's valid or not
 */
const getToken = (): string => {
  return subject.value.token;
};

/**
 * @returns whether the token is valid or not
 */
const isTokenValid = (): boolean => {
  return subject.value.isValid;
};

const setTokenDelete = (value: boolean): void => {
  const token = subject.value.token;
  subject.next({ isValid: true, token, isTokenDelete: value });
};

/**
 * @returns whether the token is should be deleted or not
 */
const isTokenDelete = (): boolean => {
  return subject.value.isTokenDelete;
};

export const longTermToken = {
  publishValidToken,
  invalidateToken,
  clearToken,
  hasToken,
  getToken,
  isTokenValid,
  subject,
  setTokenDelete,
  isTokenDelete,
};
